<template>
    <div class="item-box">
        <div v-if="isActive">
            <slot name="itemiconactive"></slot>
        </div>
        <div v-else>
            <slot name="itemicon"></slot>
        </div>

        <div class="item-text" :style="isActive ? getActiveTextStyle() : getNormalTextStyle()">
            <slot name="itemtext"></slot>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "BottomTabBarItemView",
    components: {

    },
    props: ['isActive'],
    data() {
        return {

        }
    },
    methods: {
        getActiveTextStyle() {
            return 'font-weight:bold;font-size:small;'
        },
        getNormalTextStyle() {
            return 'font-weight:normal;font-size:smaller;'
        }
    }
}
</script>
  
<style scoped lang="less">
.item-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
</style>